module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "popup__inner"
  }, [_c('button', {
    staticClass: "popup-close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close($event)
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "popup-heading"
  }, [(_vm.title) ? _c('h2', {
    staticClass: "popup-title text-center"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('div', {
    staticClass: "popup-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.description))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "popup-footer"
  }, [_vm._t("footer")], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47c9e76d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Popup.vue
// module id = 925
// module chunks = 1